import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box, Chip } from '@mui/material';
import { BugReport as BugIcon } from '@mui/icons-material';

const MobileDebug: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [debugInfo, setDebugInfo] = useState<any>({});

  // Detectar si es móvil
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  useEffect(() => {
    if (isMobile) {
      // Recolectar información de debug
      const info: any = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        onLine: navigator.onLine,
        serviceWorker: 'serviceWorker' in navigator,
        localStorage: typeof localStorage !== 'undefined',
        sessionStorage: typeof sessionStorage !== 'undefined',
        cache: typeof caches !== 'undefined',
        timestamp: new Date().toISOString(),
        url: window.location.href,
        title: document.title,
      };

      // Verificar manifest
      const manifestLink = document.querySelector('link[rel="manifest"]');
      if (manifestLink) {
        info.manifestHref = manifestLink.getAttribute('href');
      }

      setDebugInfo(info);
    }
  }, [isMobile]);

  const checkManifest = async () => {
    try {
      const response = await fetch('/manifest.json');
      const manifest = await response.json();
      setDebugInfo((prev: any) => ({
        ...prev,
        manifestName: manifest.name,
        manifestShortName: manifest.short_name,
        manifestDescription: manifest.description,
      }));
    } catch (error: any) {
      setDebugInfo((prev: any) => ({
        ...prev,
        manifestError: error.message,
      }));
    }
  };

  if (!isMobile) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 9999,
        }}
      >
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          onClick={() => setOpen(true)}
          startIcon={<BugIcon />}
          sx={{
            borderRadius: '20px',
            fontSize: '10px',
            padding: '6px 12px',
            minWidth: 'auto',
          }}
        >
          Debug
        </Button>
      </Box>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Información de Debug - PWA</DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom>
              Información del Dispositivo
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>User Agent:</strong> {debugInfo.userAgent}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Plataforma:</strong> {debugInfo.platform}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Idioma:</strong> {debugInfo.language}
            </Typography>
            <Chip 
              label={debugInfo.onLine ? "En línea" : "Sin conexión"} 
              color={debugInfo.onLine ? "success" : "error"}
              size="small"
              sx={{ mb: 1 }}
            />
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom>
              Capacidades PWA
            </Typography>
            <Chip 
              label={debugInfo.serviceWorker ? "Service Worker ✓" : "Service Worker ✗"} 
              color={debugInfo.serviceWorker ? "success" : "error"}
              size="small"
              sx={{ mr: 1, mb: 1 }}
            />
            <Chip 
              label={debugInfo.cache ? "Cache API ✓" : "Cache API ✗"} 
              color={debugInfo.cache ? "success" : "error"}
              size="small"
              sx={{ mr: 1, mb: 1 }}
            />
            <Chip 
              label={debugInfo.localStorage ? "LocalStorage ✓" : "LocalStorage ✗"} 
              color={debugInfo.localStorage ? "success" : "error"}
              size="small"
              sx={{ mb: 1 }}
            />
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom>
              Información de la Aplicación
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Título:</strong> {debugInfo.title}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>URL:</strong> {debugInfo.url}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Timestamp:</strong> {debugInfo.timestamp}
            </Typography>
          </Box>

          {debugInfo.manifestName && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="h6" gutterBottom>
                Manifest
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Nombre:</strong> {debugInfo.manifestName}
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Nombre Corto:</strong> {debugInfo.manifestShortName}
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Descripción:</strong> {debugInfo.manifestDescription}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={checkManifest} color="primary">
            Verificar Manifest
          </Button>
          <Button onClick={() => setOpen(false)}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MobileDebug; 